var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question-item" }, [
    _c("div", { staticClass: "title-box" }, [
      _c("span", { staticClass: "line-name" }, [_vm._v("选项")]),
      !_vm.readOnly
        ? _c("span", { staticClass: "line-dec" }, [
            _vm._v(
              "单选题的选项范围从" +
                _vm._s(_vm.minOptions) +
                "-" +
                _vm._s(_vm.maxOptions) +
                "个"
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "single option" }, [
      _c(
        "div",
        { staticClass: "option-content" },
        [
          _vm._l(_vm.optionsCopy, function (item, index) {
            return [
              item["exam_questions_options.ds_deleted"] !== 1
                ? _c(
                    "div",
                    {
                      key: item["exam_questions_options.ds_order"],
                      staticClass: "option-item",
                    },
                    [
                      _c("div", { staticClass: "item-line1" }, [
                        _c(
                          "div",
                          { staticClass: "item-order" },
                          [
                            _c("el-radio", {
                              attrs: {
                                disabled: _vm.readOnly,
                                label: item["exam_questions_options.ds_order"],
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeCheck(
                                    item["exam_questions_options.ds_order"]
                                  )
                                },
                              },
                              model: {
                                value: _vm.checkedOrder,
                                callback: function ($$v) {
                                  _vm.checkedOrder = $$v
                                },
                                expression: "checkedOrder",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "item-text" },
                          [
                            !_vm.readOnly
                              ? _c("el-input", {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: "请输入内容",
                                    maxlength: _vm.inputlength,
                                  },
                                  model: {
                                    value: item["exam_questions_options.name"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item,
                                        "exam_questions_options.name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item['exam_questions_options.name']",
                                  },
                                })
                              : _c("el-input", {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: "请输入内容",
                                    maxlength: _vm.inputlength,
                                    autosize: _vm.readOnly,
                                    type: "textarea",
                                  },
                                  model: {
                                    value: item["exam_questions_options.name"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item,
                                        "exam_questions_options.name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item['exam_questions_options.name']",
                                  },
                                }),
                          ],
                          1
                        ),
                        !_vm.readOnly
                          ? _c("div", { staticClass: "item-del" }, [
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteOption(item, index)
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        { staticClass: "item-line2" },
                        [
                          _c("DsfQuestionUpLoadImg", {
                            attrs: {
                              fileList: item["exam_questions_options.imgs"],
                              optionsId:
                                item["exam_questions_options.ds_order"],
                              readOnly: _vm.readOnly,
                            },
                            on: { "get-imglist": _vm.getImgList },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      !_vm.readOnly
        ? _c(
            "div",
            { staticClass: "option-add" },
            [
              _c(
                "DsfButton",
                {
                  attrs: { type: "plain", icon: "add" },
                  on: { click: _vm.addOption },
                },
                [_vm._v("添加选项")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }